import React from 'react';
import { FilterOption } from '../../../components/ui';

export const getSortOptions = (t: any): FilterOption[] => [
  { key: 'price', label: t('salesFans.price') },
  { key: '-price', label: t('salesFans.price') },
  { key: 'created_at', label: t('salesFans.added') },
  { key: '-created_at', label: t('salesFans.added') },
  { key: 'updated_at', label: t('salesFans.updated') },
  { key: '-updated_at', label: t('salesFans.updated') },
];

export const getStatusOptions = (t: any): FilterOption[] => [
  { key: 'all', label: t('salesFans.allStatuses') },
  { key: 'active', label: t('salesFans.active') },
  { key: 'inactive', label: t('salesFans.inactive') },
  { key: 'pending', label: t('salesFans.pending') },
  { key: 'suspended', label: t('salesFans.suspended') },
];

export const getTypeOptions = (t: any): FilterOption[] => [
  { key: 'all', label: t('salesFans.allTypes') },
  { key: 'marketer', label: t('salesFans.marketers') },
  { key: 'creator', label: t('salesFans.creators') },
  { key: 'traffic', label: t('salesFans.traffic') },
];

export const getMarketersTableColumns = (t: any) => [
  { name: '#', key: 'id' },
  { name: t('salesFans.marketer'), key: 'marketer' },
  { name: t('salesFans.description'), key: 'description' },
  { name: t('salesFans.orders'), key: 'orders' },
  { name: t('salesFans.status'), key: 'status' },
  { name: t('salesFans.actions'), key: 'actions' },
];

export const getCreatorsTableColumns = (t: any) => [
  { name: 'ID', key: 'id' },
  { name: t('salesFans.creator'), key: 'creator' },
  { name: t('salesFans.offer'), key: 'offer' },
  { name: t('salesFans.description'), key: 'description' },
];

export const getTrafficTableColumns = (t: any) => [
  { name: 'ID', key: 'id' },
  { name: t('salesFans.creator'), key: 'creator' },
  { name: t('salesFans.offer'), key: 'offer' },
  { name: t('salesFans.description'), key: 'description' },
];

export const getStatusLabels = (t: any) =>
  ({
    active: t('salesFans.active'),
    inactive: t('salesFans.inactive'),
    pending: t('salesFans.pending'),
    suspended: t('salesFans.suspended'),
  }) as const;

export const DEFAULT_FILTERS = {
  search: '',
  sort: 'all',
  status: 'all',
  type: 'all',
  price_min: null,
  price_max: null,
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;
